import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, RouteURLConstants, ServiceURLConstants, SUPPORT_PHONE_NUMBERS, UPS_PICKUP_POINT, UTagConstants } from '../../constants/upplm.constants';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UtagService } from '../../services/upplm.utag.service';

@Component({
    selector: 'placardexists',
    template: require('./placardExists.component.html')
})

export class PlacardExistsComponent implements OnInit, AfterViewInit {
    public sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    messageCallUpsIfDifficulty: string = '';
    messagePlacardExist: string = '';

    constructor(private router: Router,
        private _sessionService: UpplmSessionService,
        private _commonService: UpsCommonService,
        private _pbService: ProgressBarService,
        private _utagService: UtagService,
        private _translateData: TranslateDataPipe
    ) { }

    ngOnInit() {
        this.messagePlacardExist = this._translateData.transform('upplm.placardexits.aplacardalreadyexist');
        this.messagePlacardExist = this.messagePlacardExist.replace('%[x]%', UPS_PICKUP_POINT);
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_PLACARD_EXIST_START, UTagConstants.UPPLM_PLACARD_EXIST_START_SCREEN);
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;
                this._sessionService.mapSessionResponse(response);
                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocation();
                }
                if (response.locationDetails && response.locationDetails.countryKey) {
                    this.messageCallUpsIfDifficulty = this._commonService.getMessageCallUpsIfDifficulty(response.locationDetails.countryKey, this._translateData.transform('upplm.placardexits.callupsifdifficulty'));
                }
            } 
            else {
                this.SessionErrorModal.open();
            }
        });
    }

    goToLocation() {  
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    goToDashboard() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
    }

    createSessionRequest(): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.lastTimeSessionReqired = new Date().toString();
        request.placardID = this.sessionData.placardID; 
        request.placardStatus = this.sessionData.placardStatus; 
        return request;
    }


    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateData.transform('upplm.common.sessiontimedouttitle')
        });
        this.SessionErrorModal.setProperties({
            title: this._translateData.transform('upplm.common.serviceerror')
        }); 
    }

    backPage() {
        if (this.sessionData.notificationDetails) {
            if (this.sessionData.notificationDetails.showStatusBar == true) {
                this._pbService.pb = new ProgressBarDetails();
                this._pbService.pb.showStatusBar = true;
            } else {
                this._pbService.pb = new ProgressBarDetails();
                this._pbService.pb.showStatusBar = false;
            }
        } else {
            this.pbDetails = new ProgressBarDetails();
            this._pbService.pb = this.pbDetails;
            this._pbService.pb.showStatusBar = true;
        }        
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();                        
            this.ConfirmationBoxModal.open();
        }
        else {
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }
}
